<template>
    <div class="concours container home-presentation my-5 text-center">
        <h1 class="text-center text-400">
            Concours de Pitch : Présentez votre start-up et gagnez une adhésion d'un an au <span class="text-nowrap">MEDEF Côte-d'Or !</span>
        </h1>

        <p class="my-4">
            Êtes-vous prêt à relever le défi et à faire briller votre start-up ? Ne manquez pas notre concours de pitch à l'occasion de la REF21 !
            C'est une opportunité exceptionnelle de présenter votre entreprise devant un public attentif, composé d'entrepreneurs, d'investisseurs et
            de professionnels de renom.
        </p>

        <h2 class="mt-3 text-400">Comment ça marche ?</h2>

        <p>
            Vous êtes une start-up basée en Côte-d'Or avec au moins un an d'existence, vous correspondez à la thématique « Mutation(s) » et vous êtes
            prêt à pitcher 5 minutes sur votre projet sans support !
        </p>

        <div class="text-center my-5">
            <button class="btn btn-large btn-dark fs-4" disabled>INSCRIPTION</button>
        </div>

        <p class="my-4"><b>Juillet :</b> Présélection des candidatures</p>
        <p class="my-4"><b>Septembre :</b> Les start-up présélectionnées recevront un mail afin de pouvoir se préparer pour le Jour J</p>
        <p class="my-4">
            <b>28 septembre :</b> Les start-up sélectionnées auront l'opportunité de présenter leur pitch devant les partenaires de la REF21 et devant
            les entreprises présentes. Vous disposerez de quelques minutes pour convaincre et séduire l'audience avec votre vision, votre modèle
            économique et vos perspectives de croissance.
        </p>

        <p class="my-4">
            A remporter : Le gagnant du concours de pitch se verra décerner une adhésion <b>d'un an au MEDEF Côte-d'Or</b>, offrant ainsi une
            multitude d'avantages et d'opportunités pour développer sa start-up, élargir son réseau et accéder à des ressources précieuses.
        </p>

        <p>Prêt à relever le défi ? Inscrivez-vous dès maintenant au concours de pitch de la REF21 et préparez-vous à faire sensation !</p>
    </div>
</template>

<script>
export default {
    components: {},
    data() {
        return {};
    },
};
</script>
